<template>
  <div style="overflow: hidden">
    <div class="NewBuild"><Button type="info" shape="circle" icon="md-add" @click="NewBuildHandleClick">新增</Button></div>
    <Card style="width:350px;margin:1rem;float:left" v-for="item of lists" :key="item.id" class="header-icon">
        <p slot="title">
            <Avatar :src="item.icon"/>
        </p>
        <a href="#" slot="extra" @click.prevent="DrawerShow(item)">
            <Icon type="ios-create-outline" />
            编辑
        </a>
        <ul>
            <li>
                <span>
                    电话：{{ item.phone }}
                </span>
            </li>
            <li>
                <span>
                    固定电话：{{ item.FixedTelephone }}
                </span>
            </li>
            <li>
                <span>
                    工作时间：{{ item.worktime }}
                </span>
            </li>
            <li>
                <span>
                    备注：{{ item.remark }}
                </span>
            </li>
        </ul>
    </Card>
    <!-- 抽屉 -->
     <span></span>
      <Drawer title="客服信息维护" v-model="isDrawer" width="80" :mask-closable="false">
        <Form  :model="info">
          <FormItem >
               <Avatar :src="info.icon" style="margin-left:2rem"/>
               <Upload :action="baseUrl + 'uploadProject'"
                       :max-size="1024"
                       :format="['jpg','jpeg','png','ico']"
                       :show-upload-list="false"
                       :on-success="handleSuccess"
                       :on-format-error="handleFormatError"
                       :headers="headers">
                  <Button icon="ios-cloud-upload-outline">上传图标</Button>
               </Upload>
           </FormItem>
          <Row :gutter="32">
            <Col span="12">
              <FormItem label="电话" label-position="top">
                <Input  v-model="info.phone" value="info.phone" />
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="固定电话" label-position="top">
                <Input  v-model="info.FixedTelephone" value="info.FixedTelephone" />
              </FormItem>
            </Col>
          </Row>
          <FormItem label="工作时间" label-position="top">
                <Input  v-model="info.worktime" value="info.worktime" />
          </FormItem>
          <FormItem label="备注" label-position="top">
                <Input  v-model="info.remark" value="info.remark" />
          </FormItem>
        </Form>
        <div class="demo-drawer-footer">
          <Button style="margin-right: 8px" @click="CancelHandleClick">取消</Button>
          <Button type="primary" @click="SubmitHandleClick">提交</Button>
          <Poptip
            style="float:right"
            confirm
            title="你确定要删除这个客服信息吗?"
            @on-ok="DeleteHandleClick"
          >
            <Button type="error">删除</Button>
          </Poptip>
        </div>
      </Drawer>
      <Spin size="large" fix v-if="spinShow"></Spin>
  </div>
</template>

<script>
import { CustomerService, ChangeCustomerService } from '../../../api/Customer'
import config from '../../../config/index'
export default {
  name: 'CustomerService',
  data () {
    return {
      lists: [],
      isDrawer: false,
      spinShow: false,
      info: {
        id: '',
        FixedTelephone: '',
        phone: '',
        worktime: '',
        remark: '',
        icon: ''
      },
      baseUrl: '',
      headers: {
        Authorization: 'Bearer ' + this.$store.state.token
      },
      State: 0
    }
  },
  mounted: function () {
    this.baseUrl = config.baseUrl.pro
    this.GetCustomerService()
  },
  methods: {
    GetCustomerService () {
      CustomerService().then(res => {
        if (res.IsSuccess) {
          this.lists = res.Data
        } else {
          this.$Message.error(res.Message)
        }
      })
    },
    // 点击新增按钮
    NewBuildHandleClick () {
      this.info = {
        id: '',
        FixedTelephone: '',
        phone: '',
        worktime: '',
        remark: '',
        icon: ''
      }
      this.State = 0
      this.isDrawer = true
    },
    // 展示抽屉
    DrawerShow (item) {
      this.isDrawer = true
      this.State = 1
      this.info = item
    },
    // 隐藏抽屉
    CancelHandleClick () {
      this.isDrawer = false
    },
    //   上传图片成功
    handleSuccess (res, file) {
      if (res.IsSuccess) {
        this.info.icon = res.Data.url
        this.$Message['success']({
          background: true,
          content: '上传成功'
        })
      } else {
        this.$Message.error(res.Message)
      }
    },
    // 上传图片失败回调
    handleFormatError (file) {
      this.$Notice.warning({
        title: 'The file format is incorrect',
        desc: 'File format of ' + file.name + ' is incorrect, please select jpg or png.'
      })
    },
    // 提交信息
    SubmitHandleClick () {
      this.OkHandleClick()
    },
    // 删除信息回调
    DeleteHandleClick () {
      this.State = 2
      this.OkHandleClick()
    },
    // 提交接口数据
    OkHandleClick () {
      ChangeCustomerService({
        id: this.info.id,
        FixedTelephone: this.info.FixedTelephone,
        phone: this.info.phone,
        worktime: this.info.worktime,
        remark: this.info.remark,
        icon: this.info.icon,
        operation: this.State
      }).then((res) => {
        if (res.IsSuccess) {
          this.$Message['success']({
            background: true,
            content: '提交成功'
          })
          this.GetCustomerService()
          this.isDrawer = false
        } else {
          this.$Message.error(res.Message)
        }
      })
    }
  }
}
</script>
<style scoped>
.header-icon >>> .ivu-card-head p {
  height: 2rem
}
.NewBuild{
  margin-left: 1rem;
  width: 100%;
  height: 2rem;
}
</style>>
